import React from 'react';
import { FadeIn } from './FadeIn';
interface PainStoryProps {
  lang?: 'en' | 'es';
}
const t = {
  en: {
    opening: 'You already know the feeling.',
    p1: 'You sat in that chair with hope in your heart and a clear picture in your mind.',
    p2: 'You explained exactly what you wanted.',
    p3: 'You showed them the photo.',
    p4: 'And then you watched — in real time — as they did something completely different.',
    p5: 'You smiled politely. You tipped anyway. You drove home in silence.',
    truth1: "Here's what nobody in the beauty industry wants to admit:",
    truth2: 'Most salons in Waterbury are built for volume — not for you.',
    truth3: 'More clients. Faster turnover. Higher daily totals.',
    quote1a: "You're not a woman to them.",
    quote1b: "You're an appointment slot.",
    shift1: 'But what if your beauty experience felt completely different?',
    shift2: 'What if you walked through the doors at 1407 North Main Street and felt immediately at ease?',
    shift3a: 'What if someone actually listened — ',
    shift3b: 'really listened',
    shift3c: ' — and then delivered results that made you catch your breath?',
    shift4: 'What if every single visit ended with you staring in the mirror whispering:',
    quote2: "Yes. That's exactly it. That's ME.",
    close1a: "That's not a fantasy. That's ",
    close1b: 'ISASHY Beauty Center',
    close2: "And once you experience it — you'll wonder how you ever went anywhere else."
  },
  es: {
    opening: 'Ya conoces esa sensación.',
    p1: 'Te sentaste en esa silla con esperanza en el corazón y una imagen clara en tu mente.',
    p2: 'Explicaste exactamente lo que querías.',
    p3: 'Les mostraste la foto.',
    p4: 'Y entonces viste — en tiempo real — cómo hacían algo completamente diferente.',
    p5: 'Sonreíste con educación. Dejaste propina de todos modos. Manejaste a casa en silencio.',
    truth1: 'Esto es lo que nadie en la industria de la belleza quiere admitir:',
    truth2: 'La mayoría de los salones en Waterbury están hechos para volumen — no para ti.',
    truth3: 'Más clientes. Más rotación. Más ganancias diarias.',
    quote1a: 'No eres una mujer para ellos.',
    quote1b: 'Eres un turno en la agenda.',
    shift1: '¿Pero qué pasaría si tu experiencia de belleza fuera completamente diferente?',
    shift2: '¿Qué pasaría si entraras por las puertas del 1407 North Main Street y te sintieras inmediatamente en paz?',
    shift3a: '¿Qué pasaría si alguien realmente escuchara — ',
    shift3b: 'de verdad escuchara',
    shift3c: ' — y luego entregara resultados que te dejaran sin aliento?',
    shift4: '¿Qué pasaría si cada visita terminara contigo mirándote al espejo susurrando:',
    quote2: 'Sí. Eso es exactamente. Esa soy YO.',
    close1a: 'Eso no es una fantasía. Eso es ',
    close1b: 'ISASHY Beauty Center',
    close2: 'Y una vez que lo experimentes — te preguntarás cómo pudiste ir a otro lugar.'
  }
};
export function PainStory({
  lang = 'en'
}: PainStoryProps) {
  const text = t[lang];
  return <section className="py-28 md:py-40 bg-brand-dark text-brand-cream relative overflow-hidden" data-id="element-250">
      <div className="absolute top-12 left-8 md:left-16 w-[1px] h-32 bg-brand-gold/20" data-id="element-251"></div>
      <div className="absolute bottom-12 right-8 md:right-16 w-[1px] h-32 bg-brand-gold/20" data-id="element-252"></div>
      <div className="absolute top-1/2 -translate-y-1/2 -left-20 text-[200px] font-serif text-brand-cream/[0.03] leading-none select-none pointer-events-none" data-id="element-253">
        &ldquo;
      </div>

      <div className="max-w-[680px] mx-auto px-6" data-id="element-254">
        <FadeIn data-id="element-255">
          <p className="font-serif text-3xl md:text-4xl text-brand-gold leading-snug mb-16 text-center" data-id="element-256">
            {text.opening}
          </p>
        </FadeIn>

        <div className="space-y-6 font-sans text-lg md:text-[1.2rem] leading-[1.85] text-brand-cream/75" data-id="element-257">
          <FadeIn delay={0.1} data-id="element-258">
            <p data-id="element-259">{text.p1}</p>
          </FadeIn>
          <FadeIn delay={0.15} data-id="element-260">
            <p data-id="element-261">{text.p2}</p>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-262">
            <p data-id="element-263">{text.p3}</p>
          </FadeIn>
          <FadeIn delay={0.25} data-id="element-264">
            <p className="text-brand-cream/90 font-medium" data-id="element-265">{text.p4}</p>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-266">
            <p className="text-brand-cream/50 italic" data-id="element-267">{text.p5}</p>
          </FadeIn>
        </div>

        <FadeIn delay={0.1} data-id="element-268">
          <div className="flex items-center justify-center gap-4 py-16" data-id="element-269">
            <div className="w-16 h-[1px] bg-brand-gold/40" data-id="element-270"></div>
            <div className="w-2 h-2 rounded-full bg-brand-gold/40" data-id="element-271"></div>
            <div className="w-16 h-[1px] bg-brand-gold/40" data-id="element-272"></div>
          </div>
        </FadeIn>

        <div className="space-y-6 font-sans text-lg md:text-[1.2rem] leading-[1.85] text-brand-cream/75" data-id="element-273">
          <FadeIn data-id="element-274">
            <p className="font-medium text-brand-cream/90" data-id="element-275">{text.truth1}</p>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-276">
            <p data-id="element-277">{text.truth2}</p>
          </FadeIn>
          <FadeIn delay={0.15} data-id="element-278">
            <p data-id="element-279">{text.truth3}</p>
          </FadeIn>
        </div>

        <FadeIn delay={0.1} data-id="element-280">
          <div className="my-14 md:my-20 relative" data-id="element-281">
            <div className="absolute -left-4 md:-left-8 top-0 bottom-0 w-[3px] bg-brand-gold rounded-full" data-id="element-282"></div>
            <div className="bg-white/5 backdrop-blur-sm border border-brand-gold/15 px-8 md:px-12 py-8 md:py-10" data-id="element-283">
              <p className="font-serif text-2xl md:text-[2rem] text-brand-gold italic leading-snug" data-id="element-284">
                "{text.quote1a}
                <br data-id="element-285" />
                {text.quote1b}"
              </p>
            </div>
          </div>
        </FadeIn>

        <div className="space-y-6 font-sans text-lg md:text-[1.2rem] leading-[1.85] text-brand-cream/75" data-id="element-286">
          <FadeIn data-id="element-287">
            <p data-id="element-288">{text.shift1}</p>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-289">
            <p data-id="element-290">{text.shift2}</p>
          </FadeIn>
          <FadeIn delay={0.15} data-id="element-291">
            <p data-id="element-292">
              {text.shift3a}
              <em className="text-brand-cream not-italic font-medium" data-id="element-293">
                {text.shift3b}
              </em>
              {text.shift3c}
            </p>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-294">
            <p data-id="element-295">{text.shift4}</p>
          </FadeIn>
        </div>

        <FadeIn delay={0.1} data-id="element-296">
          <div className="my-14 md:my-20 text-center" data-id="element-297">
            <span className="text-6xl font-serif text-brand-gold/25 leading-none block mb-4" data-id="element-298">
              &ldquo;
            </span>
            <p className="font-serif text-3xl md:text-4xl text-brand-gold italic leading-snug" data-id="element-299">
              {text.quote2}
            </p>
            <span className="text-6xl font-serif text-brand-gold/25 leading-none block mt-4 rotate-180" data-id="element-300">
              &ldquo;
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-301">
          <div className="space-y-5 font-sans text-lg md:text-[1.2rem] leading-[1.85] text-center" data-id="element-302">
            <p className="text-brand-cream/80" data-id="element-303">
              {text.close1a}
              <span className="font-medium text-brand-gold" data-id="element-304">
                {text.close1b}
              </span>
              .
            </p>
            <p className="text-brand-cream/50 italic text-base" data-id="element-305">
              {text.close2}
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}